// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-container {
    max-width: 1200px;
    margin: 20px auto;
    padding: 20px;
    color: #fff;
    font-family: 'Kim', sans-serif;
}

.profile-container.loading,
.profile-container.error {
    text-align: center;
    padding: 40px;
    font-size: 18px;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 8px;
}

.profile-header {
    display: flex;
    align-items: flex-start;
    padding: 20px;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 8px;
    border: 2px solid #cd853f;
    margin-bottom: 20px;
    position: relative;
}

.profile-avatar {
    width: 128px;
    height: 128px;
    border-radius: 8px;
    background-size: cover;
    background-position: center;
    border: 2px solid #cd853f;
    box-shadow: 0 0 15px rgba(205, 133, 63, 0.3);
    position: relative;
}

.profile-info {
    margin-left: 20px;
    padding-right: 120px;
    min-height: 80px;
}

.profile-info h1 {
    margin: 0;
    font-size: 32px;
    color: #fff;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.profile-join-date {
    color: #aaa;
    font-size: 14px;
    margin-top: 5px;
}

.stats-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    margin-top: 20px;
}

.stats-card {
    border-radius: 8px;
    padding: 20px;
    border: 1px solid #49d7d8;
}

/* All Time Stats card - blue gradient */
.stats-card.all-time {
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.6), rgba(73, 215, 216, 0.1));
    border: 2px solid #49d7d8;
}

/* Current Season Stats card - gold/orange gradient */
.stats-card.season {
    position: relative;
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.6), rgba(205, 133, 63, 0.1));
    border: 2px solid #cd853f;
}

.league-icon {
    position: absolute;
    top: -15px;
    left: -15px;
    width: 48px;
    height: 48px;
    z-index: 1;
}

.league-icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

/* Casual Mode Stats card - green gradient */
.stats-card.casual {
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.6), rgba(73, 216, 116, 0.1));
    border: 2px solid #49d874;
}

/* Update the h2 color for each card to match its border */
.stats-card.season h2 {
    position: relative;
    z-index: 0;
    color: #cd853f;
}

.stats-card.casual h2 {
    color: #49d874;
}

/* Update the value color for each card to match its theme */
.stats-card.season .value {
    color: #cd853f;
}

.stats-card.casual .value {
    color: #49d874;
}

.stats-card h2 {
    margin: 0 0 20px 0;
    color: #49d7d8;
    font-size: 24px;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.stat-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid rgba(73, 215, 216, 0.2);
}

.stat-row:last-child {
    border-bottom: none;
}

.stat-row .value {
    font-weight: bold;
    color: #49d7d8;
}

.profile-details {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 5px;
}

.elo-rating {
    color: #49d7d8;
    font-size: 16px;
    font-weight: bold;
}

/* Tablet breakpoint */
@media (max-width: 1024px) {
    .stats-grid {
        grid-template-columns: repeat(2, 1fr);
    }
    
    /* Make the all-time stats card span full width at the top */
    .stats-card.all-time {
        grid-column: 1 / -1;
    }
}

/* Mobile breakpoint */
@media (max-width: 768px) {
    .profile-container {
        padding: 10px;
    }

    .profile-header {
        flex-direction: column;
        text-align: center;
    }

    .profile-info {
        margin-left: 0;
        margin-top: 15px;
    }

    .stats-grid {
        grid-template-columns: 1fr;
        gap: 15px;
    }
    
    /* Reset the all-time stats card span */
    .stats-card.all-time {
        grid-column: auto;
    }
} 

.player-stats {
    display: flex;
    align-items: center;
    gap: 10px;
}

.rank-divider {
    color: #666;
}

.all-time-rank {
    color: #cd853f;
    font-size: 16px;
    font-weight: bold;
}

/* Update mobile styles */
@media (max-width: 768px) {
    .player-stats {
        justify-content: center;
    }
} 

/* Add these new styles */
.search-players {
    position: relative;
    width: 100%;
    margin-bottom: 20px;
}

.search-container {
    position: relative;
    width: 100%;
}

.search-players input {
    width: 100%;
    padding: 12px;
    background: rgba(0, 0, 0, 0.4);
    border: 2px solid #49d7d8;
    border-radius: 8px;
    color: white;
    font-family: 'Kim', sans-serif;
    font-size: 16px;
}

.search-players input:focus {
    outline: none;
    border-color: #49d7d8;
    box-shadow: 0 0 10px rgba(73, 215, 216, 0.3);
}

.search-results {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.9);
    border: 2px solid #49d7d8;
    border-radius: 8px;
    margin-top: 5px;
    max-height: 300px;
    overflow-y: auto;
    z-index: 1000;
}

.player-result {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid rgba(73, 215, 216, 0.2);
}

.player-result:last-child {
    border-bottom: none;
}

.player-info {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
    min-width: 0;
}

.player-avatar {
    width: 32px;
    height: 32px;
    border-radius: 4px;
    background-size: cover;
    background-position: center;
    border: 1px solid #49d7d8;
}

.player-name {
    color: white;
    font-size: 14px;
    word-wrap: break-word;
    white-space: normal;
    line-height: 1.2;
    flex: 1;
    padding-right: 10px;
}

.add-friend-btn {
    background: linear-gradient(135deg, #ffd700, #cd853f);
    border: none;
    border-radius: 4px;
    color: white;
    padding: 6px 12px;
    cursor: pointer;
    font-family: 'Kim', sans-serif;
    font-size: 12px;
    transition: all 0.2s ease;
    text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
}

.add-friend-btn:hover {
    transform: scale(1.05);
    background: linear-gradient(135deg, #ffe44d, #dea164);
}

.search-loading {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #49d7d8;
    font-size: 14px;
}

.search-error {
    color: #ff6b6b;
    padding: 10px;
    text-align: center;
}

.no-results {
    color: #666;
    padding: 10px;
    text-align: center;
} 

/* Add these new styles */
.profile-add-friend {
    position: absolute;
    right: 20px;
    top: 20px;
    background: linear-gradient(135deg, #ffd700, #cd853f);
    border: none;
    border-radius: 4px;
    color: white;
    padding: 8px 16px;
    cursor: pointer;
    font-family: 'Kim', sans-serif;
    font-size: 14px;
    transition: all 0.2s ease;
    text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
    min-width: 100px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.button-spinner {
    width: 20px;
    height: 20px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
.profile-add-friend:hover {
    transform: scale(1.05);
    background: linear-gradient(135deg, #ffe44d, #dea164);
    box-shadow: 0 0 10px rgba(255, 215, 0, 0.3);
} 

.profile-add-friend.is-friend {
    background: linear-gradient(135deg, #49d874, #2a7a4b);
    cursor: default;
    opacity: 0.9;
}

.profile-add-friend.is-friend:hover {
    transform: none;
    box-shadow: none;
    background: linear-gradient(135deg, #49d874, #2a7a4b);
} 

/* Add these new styles */
.friends-mosaic {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 20px;
    margin-top: 20px;
    padding: 20px;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 8px;
}

.friend-tile {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 10px;
    border-radius: 8px;
}

.friend-tile:hover {
    transform: scale(1.1);
    background: rgba(73, 215, 216, 0.1);
}

.friend-avatar {
    width: 64px;
    height: 64px;
    border-radius: 8px;
    background-size: cover;
    background-position: center;
    border: 2px solid #49d7d8;
    box-shadow: 0 0 10px rgba(73, 215, 216, 0.3);
    transition: all 0.3s ease;
    position: relative;
}

.friend-tile:hover .friend-avatar {
    border-color: #5ae8e9;
    box-shadow: 0 0 15px rgba(73, 215, 216, 0.5);
}

.friend-name {
    color: white;
    font-size: 14px;
    text-align: center;
    max-width: 90px;
    word-wrap: break-word;
    white-space: normal;
    line-height: 1.2;
}

.no-friends {
    grid-column: 1 / -1;
    text-align: center;
    color: #666;
    padding: 20px;
    font-size: 16px;
}

/* Update existing styles */
.friends-section {
    margin-top: 30px;
}

.friends-section h2 {
    margin-bottom: 20px;
    color: #49d7d8;
    font-size: 24px;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
} 

/* Update the add friend button styles in search results */
.add-friend-btn {
    background: linear-gradient(135deg, #ffd700, #cd853f);
    border: none;
    border-radius: 4px;
    color: white;
    padding: 6px 12px;
    cursor: pointer;
    font-family: 'Kim', sans-serif;
    font-size: 12px;
    transition: all 0.2s ease;
    text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
}

.add-friend-btn:hover {
    transform: scale(1.05);
    background: linear-gradient(135deg, #ffe44d, #dea164);
}

/* Style for when already friends - remove hover effects and use green gradient */
.add-friend-btn.is-friend {
    background: linear-gradient(135deg, #49d874, #2a7a4b);
    cursor: default;
    opacity: 0.9;
    transform: none;
    transition: none;
}

.add-friend-btn.is-friend:hover {
    transform: none;
    background: linear-gradient(135deg, #49d874, #2a7a4b);
} 

.player-status {
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 0.9em;
    margin-top: 4px;
}

.status-online {
    background-color: #4CAF50;
    color: white;
}

.status-offline {
    background-color: #9e9e9e;
    color: white;
}

.status-ingame {
    background-color: #2196F3;
    color: white;
}

.status-queuing {
    background-color: #FF9800;
    color: white;
}

.player-status a {
    color: white;
    text-decoration: underline;
    margin-left: 4px;
}

.friend-tile .player-status {
    font-size: 0.8em;
    margin-top: 2px;
} 

/* Replace the existing player-status styles with these */
.status-dot {
    position: absolute;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 2px solid #1a1a1a;
    right: 3px;
    top: 3px;
}

.status-dot.online {
    background-color: #4CAF50;
}

.status-dot.offline {
    background-color: #9e9e9e;
}

.status-dot.queuing {
    background-color: #2196F3;
}

.status-dot.ingame {
    background-color: #f44336;
}

/* Add spectate badge for in-game status */
.spectate-badge {
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 10px;
    white-space: nowrap;
    cursor: pointer;
    border: 1px solid #f44336;
}

.spectate-badge:hover {
    background: #f44336;
} 

/* Add these new styles */
.player-status-box {
    background: rgba(0, 0, 0, 0.4);
    border-radius: 8px;
    padding: 15px 20px;
    margin: 20px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 2px solid;
    transition: all 0.3s ease;
}

.player-status-box.online {
    border-color: #4CAF50;
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.6), rgba(76, 175, 80, 0.1));
}

.player-status-box.offline {
    border-color: #9e9e9e;
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.6), rgba(158, 158, 158, 0.1));
}

.player-status-box.queuing {
    border-color: #2196F3;
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.6), rgba(33, 150, 243, 0.1));
}

.player-status-box.ingame {
    border-color: #f44336;
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.6), rgba(244, 67, 54, 0.1));
}

.status-text {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
}

.status-text .status-dot {
    position: static;
    margin-right: 5px;
}

.challenge-button {
    background: linear-gradient(135deg, #ffd700, #cd853f);
    border: none;
    border-radius: 4px;
    color: white;
    padding: 8px 16px;
    cursor: pointer;
    font-family: 'Kim', sans-serif;
    font-size: 14px;
    transition: all 0.2s ease;
    text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
}

.challenge-button:hover {
    transform: scale(1.05);
    background: linear-gradient(135deg, #ffe44d, #dea164);
    box-shadow: 0 0 10px rgba(255, 215, 0, 0.3);
}

.status-message {
    color: #fff;
} 

/* Challenge Modal Styles */
.challenge-modal {
    position: relative;
    padding-top: 30px !important;
}

.challenge-modal .challenger-avatar {
    position: absolute;
    top: -30px;
    left: -30px;
    width: 80px;
    height: 80px;
    border-radius: 8px;
    background-size: cover;
    background-position: center;
    border: 4px solid #ffd700;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    animation: glowPulse 2s infinite;
}

/* Add the pulsating glow animation */
@keyframes glowPulse {
    0% {
        box-shadow: 0 0 5px #ffd700, 0 0 10px #ffd700, 0 0 15px #ffd700;
    }
    50% {
        box-shadow: 0 0 10px #ffd700, 0 0 20px #ffd700, 0 0 30px #ffd700;
    }
    100% {
        box-shadow: 0 0 5px #ffd700, 0 0 10px #ffd700, 0 0 15px #ffd700;
    }
}

.challenge-modal .challenge-description {
    text-align: center;
    margin: 30px 0;
    color: white;
    font-size: 24px;
    line-height: 1.4;
}

.challenge-modal .highlight-name {
    color: #f9d400;
    font-weight: bold;
    font-size: 26px;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

/* Add emphasis to the second paragraph */
.challenge-modal .challenge-description p:last-child {
    font-size: 20px;
    opacity: 0.8;
    margin-top: 20px;
}

/* Update modal buttons to use gradients */
.challenge-modal .cancel-btn {
    background: linear-gradient(135deg, #666, #444);
    border: none;
    padding: 10px 20px;
    font-size: 16px;
    transition: all 0.3s ease;
}

.challenge-modal .cancel-btn:hover {
    background: linear-gradient(135deg, #777, #555);
    transform: scale(1.05);
}

.challenge-modal .confirm-btn {
    background: linear-gradient(135deg, #ffd700, #daa520);
    border: none;
    padding: 10px 20px;
    font-size: 16px;
    transition: all 0.3s ease;
}

.challenge-modal .confirm-btn:hover {
    background: linear-gradient(135deg, #fff700, #ffd700);
    transform: scale(1.05);
    box-shadow: 0 0 15px rgba(255, 215, 0, 0.5);
} 

/* Challenge Response Modal Styles */
.challenge-response-modal {
    position: relative;
    padding-top: 30px !important;
}

.challenge-response-modal .challenger-avatar {
    position: absolute;
    top: -30px;
    left: -30px;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
    border: 4px solid #cd853f;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease;
}

.challenge-response-modal h3 {
    position: absolute;
    top: -18px;
    left: 50%;
    transform: translateX(-50%);
    background: var(--background-color);
    padding: 0 20px;
    margin: 0;
    color: white;
    font-size: 32px;
    text-transform: uppercase;
    text-shadow: -2px -2px 0 #000,  
                  2px -2px 0 #000,
                 -2px  2px 0 #000,
                  2px  2px 0 #000;
    z-index: 2;
}

.challenge-response-modal::before {
    content: '';
    position: absolute;
    top: -2px;
    left: 50%;
    transform: translateX(-50%);
    width: 120px;
    height: 4px;
    background: var(--background-color);
    z-index: 1;
}

.challenge-response-modal .challenge-description {
    text-align: center;
    margin: 30px 0;
    color: var(--text-color-secondary);
    font-size: 24px;
    line-height: 1.4;
}

.challenge-response-modal .highlight-name {
    color: #ffd700;
    font-weight: bold;
    font-size: 26px;
}

.challenge-response-modal .button-container {
    display: flex;
    gap: 20px;
    justify-content: center;
}

.challenge-response-modal .accept-btn {
    background: linear-gradient(135deg, #4CAF50, #45a049);
    border: none;
    padding: 10px 30px;
    font-size: 16px;
    transition: all 0.3s ease;
}

.challenge-response-modal .accept-btn:hover {
    background: linear-gradient(135deg, #45a049, #4CAF50);
    transform: scale(1.05);
}

.challenge-response-modal .decline-btn {
    background: linear-gradient(135deg, #f44336, #d32f2f);
    border: none;
    padding: 10px 30px;
    font-size: 16px;
    transition: all 0.3s ease;
}

.challenge-response-modal .decline-btn:hover {
    background: linear-gradient(135deg, #d32f2f, #f44336);
    transform: scale(1.05);
} 


.challenge-modal h3 {
    position: absolute;
    top: -18px;
    left: 50%;
    transform: translateX(-50%);
    background: var(--background-color);
    padding: 0 20px;
    margin: 0;
    color: white;
    font-size: 32px;
    text-transform: uppercase;
    text-shadow: -2px -2px 0 #000,  
                  2px -2px 0 #000,
                 -2px  2px 0 #000,
                  2px  2px 0 #000;
    z-index: 2;
}   

/* Add these styles */
.profile-name-container {
    display: flex;
    align-items: center;
    gap: 8px;
}

.edit-name-icon {
    cursor: pointer;
    opacity: 0.7;
    transition: opacity 0.2s;
    padding: 4px;
}

.edit-name-icon:hover {
    opacity: 1;
}

.name-edit-form {
    display: flex;
    align-items: center;
    gap: 8px;
}

.name-edit-input {
    font-size: 24px;
    padding: 4px 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.1);
    color: inherit;
}

.name-edit-spinner {
    width: 20px;
    height: 20px;
    border: 2px solid transparent;
    border-top-color: currentColor;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-left: 8px;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}   

.name-edit-form button {
    border: none;
    border-radius: 4px;
    color: white;
    padding: 8px 16px;
    cursor: pointer;
    font-family: 'Kim', sans-serif;
    font-size: 14px;
    transition: all 0.2s ease;
    text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
}

.name-edit-form button[type="submit"] {
    background: linear-gradient(135deg, #ffd700, #cd853f);
}

.name-edit-form button[type="submit"]:hover {
    transform: scale(1.05);
    background: linear-gradient(135deg, #ffe44d, #dea164);
    box-shadow: 0 0 10px rgba(255, 215, 0, 0.3);
}

.name-edit-form button[type="button"] {
    background: linear-gradient(135deg, #666, #444);
}

.name-edit-form button[type="button"]:hover {
    transform: scale(1.05);
    background: linear-gradient(135deg, #777, #555);
}   

/* Add these styles */
.profile-avatar {
    position: relative;
}

.profile-avatar:hover .edit-avatar-icon {
    opacity: 1;
}

.edit-avatar-icon {
    position: absolute;
    bottom: 8px;
    right: 8px;
    width: 32px;
    height: 32px;
    background: rgba(0, 0, 0, 0.8);
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.2s ease;
    border: 1px solid rgba(255, 255, 255, 0.4);
    padding: 8px;
}

.edit-avatar-icon svg {
    stroke: #ffffff;
    opacity: 0.9;
    width: 100%;
    height: 100%;
}

.edit-avatar-icon:hover {
    background: rgba(0, 0, 0, 0.9);
    border-color: rgba(255, 255, 255, 0.6);
}

.edit-avatar-icon:hover svg {
    opacity: 1;
}

.avatar-gallery-modal {
    background: rgba(0, 0, 0, 0.85);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
}

.avatar-gallery {
    background: #242b37;
    padding: 20px;
    border-radius: 8px;
    max-width: 90%;
    max-height: 90vh;
    overflow-y: auto;
}

.avatar-gallery-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.avatar-gallery-header h3 {
    margin: 0;
    color: #fff;
}

.avatar-gallery-close {
    background: none;
    border: none;
    color: #fff;
    cursor: pointer;
    font-size: 24px;
    padding: 0;
}

.avatar-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
    gap: 10px;
    max-width: 600px;
}

.avatar-option {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-size: 120%;
    background-position: center;
    cursor: pointer;
    border: 2px solid transparent;
    transition: all 0.2s ease;
}

.avatar-option:hover {
    border-color: #4a90e2;
    background-size: 130%;
}

.avatar-option.selected {
    border-color: #ffd700;
    box-shadow: 0 0 10px rgba(255, 215, 0, 0.5);
    background-size: 130%;
}   

.avatar-gallery .loading {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.7);  /* Semi-transparent overlay */
    border-radius: 8px;
}

.avatar-gallery .loading-spinner {
    width: 40px;
    height: 40px;
    border: 3px solid rgba(255, 255, 255, 0.1);
    border-top-color: #ffd700;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}   `, "",{"version":3,"sources":["webpack://./src/components/profile/profile.style.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,8BAA8B;AAClC;;AAEA;;IAEI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;IAC3B,yBAAyB;IACzB,4CAA4C;IAC5C,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;IACX,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,yBAAyB;AAC7B;;AAEA,wCAAwC;AACxC;IACI,gFAAgF;IAChF,yBAAyB;AAC7B;;AAEA,qDAAqD;AACrD;IACI,kBAAkB;IAClB,gFAAgF;IAChF,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA,4CAA4C;AAC5C;IACI,gFAAgF;IAChF,yBAAyB;AAC7B;;AAEA,0DAA0D;AAC1D;IACI,kBAAkB;IAClB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,4DAA4D;AAC5D;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gDAAgD;AACpD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA,sBAAsB;AACtB;IACI;QACI,qCAAqC;IACzC;;IAEA,4DAA4D;IAC5D;QACI,mBAAmB;IACvB;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA,uCAAuC;IACvC;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA,yBAAyB;AACzB;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,8BAA8B;IAC9B,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,gDAAgD;AACpD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,OAAO;IACP,mBAAmB;AACvB;;AAEA;IACI,qDAAqD;IACrD,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,8BAA8B;IAC9B,eAAe;IACf,yBAAyB;IACzB,+EAA+E;AACnF;;AAEA;IACI,sBAAsB;IACtB,qDAAqD;AACzD;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,qDAAqD;IACrD,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,8BAA8B;IAC9B,eAAe;IACf,yBAAyB;IACzB,+EAA+E;IAC/E,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,uBAAuB;IACvB,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI,sBAAsB;IACtB,qDAAqD;IACrD,2CAA2C;AAC/C;;AAEA;IACI,qDAAqD;IACrD,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qDAAqD;AACzD;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;IAC3B,yBAAyB;IACzB,4CAA4C;IAC5C,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,eAAe;AACnB;;AAEA,2BAA2B;AAC3B;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,2CAA2C;AAC/C;;AAEA,0DAA0D;AAC1D;IACI,qDAAqD;IACrD,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,8BAA8B;IAC9B,eAAe;IACf,yBAAyB;IACzB,+EAA+E;AACnF;;AAEA;IACI,sBAAsB;IACtB,qDAAqD;AACzD;;AAEA,iFAAiF;AACjF;IACI,qDAAqD;IACrD,eAAe;IACf,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,qDAAqD;AACzD;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA,yDAAyD;AACzD;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,0CAA0C;AAC1C;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,yBAAyB;AACzB;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,+EAA+E;AACnF;;AAEA;IACI,qBAAqB;IACrB,iFAAiF;AACrF;;AAEA;IACI,qBAAqB;IACrB,gFAAgF;AACpF;;AAEA;IACI,qBAAqB;IACrB,+EAA+E;AACnF;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,qDAAqD;IACrD,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,8BAA8B;IAC9B,eAAe;IACf,yBAAyB;IACzB,+EAA+E;AACnF;;AAEA;IACI,sBAAsB;IACtB,qDAAqD;IACrD,2CAA2C;AAC/C;;AAEA;IACI,WAAW;AACf;;AAEA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;IAC3B,yBAAyB;IACzB,wCAAwC;IACxC,gCAAgC;AACpC;;AAEA,qCAAqC;AACrC;IACI;QACI,+DAA+D;IACnE;IACA;QACI,gEAAgE;IACpE;IACA;QACI,+DAA+D;IACnE;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,2CAA2C;AAC/C;;AAEA,yCAAyC;AACzC;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA,0CAA0C;AAC1C;IACI,+CAA+C;IAC/C,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,+CAA+C;IAC/C,sBAAsB;AAC1B;;AAEA;IACI,qDAAqD;IACrD,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,qDAAqD;IACrD,sBAAsB;IACtB,2CAA2C;AAC/C;;AAEA,oCAAoC;AACpC;IACI,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;IAC3B,yBAAyB;IACzB,wCAAwC;IACxC,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,2BAA2B;IAC3B,mCAAmC;IACnC,eAAe;IACf,SAAS;IACT,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB;;;iCAG6B;IAC7B,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,YAAY;IACZ,WAAW;IACX,mCAAmC;IACnC,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kCAAkC;IAClC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,qDAAqD;IACrD,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,qDAAqD;IACrD,sBAAsB;AAC1B;;AAEA;IACI,qDAAqD;IACrD,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,qDAAqD;IACrD,sBAAsB;AAC1B;;;AAGA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,2BAA2B;IAC3B,mCAAmC;IACnC,eAAe;IACf,SAAS;IACT,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB;;;iCAG6B;IAC7B,UAAU;AACd;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,8BAA8B;IAC9B,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,8BAA8B;IAC9B,eAAe;IACf,yBAAyB;IACzB,+EAA+E;AACnF;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,sBAAsB;IACtB,qDAAqD;IACrD,2CAA2C;AAC/C;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,sBAAsB;IACtB,+CAA+C;AACnD;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,6BAA6B;IAC7B,0CAA0C;IAC1C,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,sCAAsC;AAC1C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;IACf,UAAU;AACd;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,2BAA2B;IAC3B,eAAe;IACf,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,2CAA2C;IAC3C,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B,GAAG,6BAA6B;IAC9D,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,yBAAyB;IACzB,kBAAkB;IAClB,kCAAkC;AACtC","sourcesContent":[".profile-container {\n    max-width: 1200px;\n    margin: 20px auto;\n    padding: 20px;\n    color: #fff;\n    font-family: 'Kim', sans-serif;\n}\n\n.profile-container.loading,\n.profile-container.error {\n    text-align: center;\n    padding: 40px;\n    font-size: 18px;\n    background: rgba(0, 0, 0, 0.4);\n    border-radius: 8px;\n}\n\n.profile-header {\n    display: flex;\n    align-items: flex-start;\n    padding: 20px;\n    background: rgba(0, 0, 0, 0.4);\n    border-radius: 8px;\n    border: 2px solid #cd853f;\n    margin-bottom: 20px;\n    position: relative;\n}\n\n.profile-avatar {\n    width: 128px;\n    height: 128px;\n    border-radius: 8px;\n    background-size: cover;\n    background-position: center;\n    border: 2px solid #cd853f;\n    box-shadow: 0 0 15px rgba(205, 133, 63, 0.3);\n    position: relative;\n}\n\n.profile-info {\n    margin-left: 20px;\n    padding-right: 120px;\n    min-height: 80px;\n}\n\n.profile-info h1 {\n    margin: 0;\n    font-size: 32px;\n    color: #fff;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\n}\n\n.profile-join-date {\n    color: #aaa;\n    font-size: 14px;\n    margin-top: 5px;\n}\n\n.stats-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 20px;\n    margin-top: 20px;\n}\n\n.stats-card {\n    border-radius: 8px;\n    padding: 20px;\n    border: 1px solid #49d7d8;\n}\n\n/* All Time Stats card - blue gradient */\n.stats-card.all-time {\n    background: linear-gradient(135deg, rgba(0, 0, 0, 0.6), rgba(73, 215, 216, 0.1));\n    border: 2px solid #49d7d8;\n}\n\n/* Current Season Stats card - gold/orange gradient */\n.stats-card.season {\n    position: relative;\n    background: linear-gradient(135deg, rgba(0, 0, 0, 0.6), rgba(205, 133, 63, 0.1));\n    border: 2px solid #cd853f;\n}\n\n.league-icon {\n    position: absolute;\n    top: -15px;\n    left: -15px;\n    width: 48px;\n    height: 48px;\n    z-index: 1;\n}\n\n.league-icon img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n/* Casual Mode Stats card - green gradient */\n.stats-card.casual {\n    background: linear-gradient(135deg, rgba(0, 0, 0, 0.6), rgba(73, 216, 116, 0.1));\n    border: 2px solid #49d874;\n}\n\n/* Update the h2 color for each card to match its border */\n.stats-card.season h2 {\n    position: relative;\n    z-index: 0;\n    color: #cd853f;\n}\n\n.stats-card.casual h2 {\n    color: #49d874;\n}\n\n/* Update the value color for each card to match its theme */\n.stats-card.season .value {\n    color: #cd853f;\n}\n\n.stats-card.casual .value {\n    color: #49d874;\n}\n\n.stats-card h2 {\n    margin: 0 0 20px 0;\n    color: #49d7d8;\n    font-size: 24px;\n    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n.stat-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 0;\n    border-bottom: 1px solid rgba(73, 215, 216, 0.2);\n}\n\n.stat-row:last-child {\n    border-bottom: none;\n}\n\n.stat-row .value {\n    font-weight: bold;\n    color: #49d7d8;\n}\n\n.profile-details {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-top: 5px;\n}\n\n.elo-rating {\n    color: #49d7d8;\n    font-size: 16px;\n    font-weight: bold;\n}\n\n/* Tablet breakpoint */\n@media (max-width: 1024px) {\n    .stats-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n    \n    /* Make the all-time stats card span full width at the top */\n    .stats-card.all-time {\n        grid-column: 1 / -1;\n    }\n}\n\n/* Mobile breakpoint */\n@media (max-width: 768px) {\n    .profile-container {\n        padding: 10px;\n    }\n\n    .profile-header {\n        flex-direction: column;\n        text-align: center;\n    }\n\n    .profile-info {\n        margin-left: 0;\n        margin-top: 15px;\n    }\n\n    .stats-grid {\n        grid-template-columns: 1fr;\n        gap: 15px;\n    }\n    \n    /* Reset the all-time stats card span */\n    .stats-card.all-time {\n        grid-column: auto;\n    }\n} \n\n.player-stats {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.rank-divider {\n    color: #666;\n}\n\n.all-time-rank {\n    color: #cd853f;\n    font-size: 16px;\n    font-weight: bold;\n}\n\n/* Update mobile styles */\n@media (max-width: 768px) {\n    .player-stats {\n        justify-content: center;\n    }\n} \n\n/* Add these new styles */\n.search-players {\n    position: relative;\n    width: 100%;\n    margin-bottom: 20px;\n}\n\n.search-container {\n    position: relative;\n    width: 100%;\n}\n\n.search-players input {\n    width: 100%;\n    padding: 12px;\n    background: rgba(0, 0, 0, 0.4);\n    border: 2px solid #49d7d8;\n    border-radius: 8px;\n    color: white;\n    font-family: 'Kim', sans-serif;\n    font-size: 16px;\n}\n\n.search-players input:focus {\n    outline: none;\n    border-color: #49d7d8;\n    box-shadow: 0 0 10px rgba(73, 215, 216, 0.3);\n}\n\n.search-results {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background: rgba(0, 0, 0, 0.9);\n    border: 2px solid #49d7d8;\n    border-radius: 8px;\n    margin-top: 5px;\n    max-height: 300px;\n    overflow-y: auto;\n    z-index: 1000;\n}\n\n.player-result {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px;\n    border-bottom: 1px solid rgba(73, 215, 216, 0.2);\n}\n\n.player-result:last-child {\n    border-bottom: none;\n}\n\n.player-info {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex: 1;\n    min-width: 0;\n}\n\n.player-avatar {\n    width: 32px;\n    height: 32px;\n    border-radius: 4px;\n    background-size: cover;\n    background-position: center;\n    border: 1px solid #49d7d8;\n}\n\n.player-name {\n    color: white;\n    font-size: 14px;\n    word-wrap: break-word;\n    white-space: normal;\n    line-height: 1.2;\n    flex: 1;\n    padding-right: 10px;\n}\n\n.add-friend-btn {\n    background: linear-gradient(135deg, #ffd700, #cd853f);\n    border: none;\n    border-radius: 4px;\n    color: white;\n    padding: 6px 12px;\n    cursor: pointer;\n    font-family: 'Kim', sans-serif;\n    font-size: 12px;\n    transition: all 0.2s ease;\n    text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;\n}\n\n.add-friend-btn:hover {\n    transform: scale(1.05);\n    background: linear-gradient(135deg, #ffe44d, #dea164);\n}\n\n.search-loading {\n    position: absolute;\n    right: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #49d7d8;\n    font-size: 14px;\n}\n\n.search-error {\n    color: #ff6b6b;\n    padding: 10px;\n    text-align: center;\n}\n\n.no-results {\n    color: #666;\n    padding: 10px;\n    text-align: center;\n} \n\n/* Add these new styles */\n.profile-add-friend {\n    position: absolute;\n    right: 20px;\n    top: 20px;\n    background: linear-gradient(135deg, #ffd700, #cd853f);\n    border: none;\n    border-radius: 4px;\n    color: white;\n    padding: 8px 16px;\n    cursor: pointer;\n    font-family: 'Kim', sans-serif;\n    font-size: 14px;\n    transition: all 0.2s ease;\n    text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;\n    min-width: 100px;\n    height: 35px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.button-spinner {\n    width: 20px;\n    height: 20px;\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    border-top-color: white;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n.profile-add-friend:hover {\n    transform: scale(1.05);\n    background: linear-gradient(135deg, #ffe44d, #dea164);\n    box-shadow: 0 0 10px rgba(255, 215, 0, 0.3);\n} \n\n.profile-add-friend.is-friend {\n    background: linear-gradient(135deg, #49d874, #2a7a4b);\n    cursor: default;\n    opacity: 0.9;\n}\n\n.profile-add-friend.is-friend:hover {\n    transform: none;\n    box-shadow: none;\n    background: linear-gradient(135deg, #49d874, #2a7a4b);\n} \n\n/* Add these new styles */\n.friends-mosaic {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n    gap: 20px;\n    margin-top: 20px;\n    padding: 20px;\n    background: rgba(0, 0, 0, 0.4);\n    border-radius: 8px;\n}\n\n.friend-tile {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    padding: 10px;\n    border-radius: 8px;\n}\n\n.friend-tile:hover {\n    transform: scale(1.1);\n    background: rgba(73, 215, 216, 0.1);\n}\n\n.friend-avatar {\n    width: 64px;\n    height: 64px;\n    border-radius: 8px;\n    background-size: cover;\n    background-position: center;\n    border: 2px solid #49d7d8;\n    box-shadow: 0 0 10px rgba(73, 215, 216, 0.3);\n    transition: all 0.3s ease;\n    position: relative;\n}\n\n.friend-tile:hover .friend-avatar {\n    border-color: #5ae8e9;\n    box-shadow: 0 0 15px rgba(73, 215, 216, 0.5);\n}\n\n.friend-name {\n    color: white;\n    font-size: 14px;\n    text-align: center;\n    max-width: 90px;\n    word-wrap: break-word;\n    white-space: normal;\n    line-height: 1.2;\n}\n\n.no-friends {\n    grid-column: 1 / -1;\n    text-align: center;\n    color: #666;\n    padding: 20px;\n    font-size: 16px;\n}\n\n/* Update existing styles */\n.friends-section {\n    margin-top: 30px;\n}\n\n.friends-section h2 {\n    margin-bottom: 20px;\n    color: #49d7d8;\n    font-size: 24px;\n    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);\n} \n\n/* Update the add friend button styles in search results */\n.add-friend-btn {\n    background: linear-gradient(135deg, #ffd700, #cd853f);\n    border: none;\n    border-radius: 4px;\n    color: white;\n    padding: 6px 12px;\n    cursor: pointer;\n    font-family: 'Kim', sans-serif;\n    font-size: 12px;\n    transition: all 0.2s ease;\n    text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;\n}\n\n.add-friend-btn:hover {\n    transform: scale(1.05);\n    background: linear-gradient(135deg, #ffe44d, #dea164);\n}\n\n/* Style for when already friends - remove hover effects and use green gradient */\n.add-friend-btn.is-friend {\n    background: linear-gradient(135deg, #49d874, #2a7a4b);\n    cursor: default;\n    opacity: 0.9;\n    transform: none;\n    transition: none;\n}\n\n.add-friend-btn.is-friend:hover {\n    transform: none;\n    background: linear-gradient(135deg, #49d874, #2a7a4b);\n} \n\n.player-status {\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-size: 0.9em;\n    margin-top: 4px;\n}\n\n.status-online {\n    background-color: #4CAF50;\n    color: white;\n}\n\n.status-offline {\n    background-color: #9e9e9e;\n    color: white;\n}\n\n.status-ingame {\n    background-color: #2196F3;\n    color: white;\n}\n\n.status-queuing {\n    background-color: #FF9800;\n    color: white;\n}\n\n.player-status a {\n    color: white;\n    text-decoration: underline;\n    margin-left: 4px;\n}\n\n.friend-tile .player-status {\n    font-size: 0.8em;\n    margin-top: 2px;\n} \n\n/* Replace the existing player-status styles with these */\n.status-dot {\n    position: absolute;\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    border: 2px solid #1a1a1a;\n    right: 3px;\n    top: 3px;\n}\n\n.status-dot.online {\n    background-color: #4CAF50;\n}\n\n.status-dot.offline {\n    background-color: #9e9e9e;\n}\n\n.status-dot.queuing {\n    background-color: #2196F3;\n}\n\n.status-dot.ingame {\n    background-color: #f44336;\n}\n\n/* Add spectate badge for in-game status */\n.spectate-badge {\n    position: absolute;\n    bottom: -8px;\n    left: 50%;\n    transform: translateX(-50%);\n    background: rgba(0, 0, 0, 0.8);\n    color: white;\n    padding: 2px 6px;\n    border-radius: 4px;\n    font-size: 10px;\n    white-space: nowrap;\n    cursor: pointer;\n    border: 1px solid #f44336;\n}\n\n.spectate-badge:hover {\n    background: #f44336;\n} \n\n/* Add these new styles */\n.player-status-box {\n    background: rgba(0, 0, 0, 0.4);\n    border-radius: 8px;\n    padding: 15px 20px;\n    margin: 20px 0;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border: 2px solid;\n    transition: all 0.3s ease;\n}\n\n.player-status-box.online {\n    border-color: #4CAF50;\n    background: linear-gradient(135deg, rgba(0, 0, 0, 0.6), rgba(76, 175, 80, 0.1));\n}\n\n.player-status-box.offline {\n    border-color: #9e9e9e;\n    background: linear-gradient(135deg, rgba(0, 0, 0, 0.6), rgba(158, 158, 158, 0.1));\n}\n\n.player-status-box.queuing {\n    border-color: #2196F3;\n    background: linear-gradient(135deg, rgba(0, 0, 0, 0.6), rgba(33, 150, 243, 0.1));\n}\n\n.player-status-box.ingame {\n    border-color: #f44336;\n    background: linear-gradient(135deg, rgba(0, 0, 0, 0.6), rgba(244, 67, 54, 0.1));\n}\n\n.status-text {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 16px;\n}\n\n.status-text .status-dot {\n    position: static;\n    margin-right: 5px;\n}\n\n.challenge-button {\n    background: linear-gradient(135deg, #ffd700, #cd853f);\n    border: none;\n    border-radius: 4px;\n    color: white;\n    padding: 8px 16px;\n    cursor: pointer;\n    font-family: 'Kim', sans-serif;\n    font-size: 14px;\n    transition: all 0.2s ease;\n    text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;\n}\n\n.challenge-button:hover {\n    transform: scale(1.05);\n    background: linear-gradient(135deg, #ffe44d, #dea164);\n    box-shadow: 0 0 10px rgba(255, 215, 0, 0.3);\n}\n\n.status-message {\n    color: #fff;\n} \n\n/* Challenge Modal Styles */\n.challenge-modal {\n    position: relative;\n    padding-top: 30px !important;\n}\n\n.challenge-modal .challenger-avatar {\n    position: absolute;\n    top: -30px;\n    left: -30px;\n    width: 80px;\n    height: 80px;\n    border-radius: 8px;\n    background-size: cover;\n    background-position: center;\n    border: 4px solid #ffd700;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    animation: glowPulse 2s infinite;\n}\n\n/* Add the pulsating glow animation */\n@keyframes glowPulse {\n    0% {\n        box-shadow: 0 0 5px #ffd700, 0 0 10px #ffd700, 0 0 15px #ffd700;\n    }\n    50% {\n        box-shadow: 0 0 10px #ffd700, 0 0 20px #ffd700, 0 0 30px #ffd700;\n    }\n    100% {\n        box-shadow: 0 0 5px #ffd700, 0 0 10px #ffd700, 0 0 15px #ffd700;\n    }\n}\n\n.challenge-modal .challenge-description {\n    text-align: center;\n    margin: 30px 0;\n    color: white;\n    font-size: 24px;\n    line-height: 1.4;\n}\n\n.challenge-modal .highlight-name {\n    color: #f9d400;\n    font-weight: bold;\n    font-size: 26px;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\n}\n\n/* Add emphasis to the second paragraph */\n.challenge-modal .challenge-description p:last-child {\n    font-size: 20px;\n    opacity: 0.8;\n    margin-top: 20px;\n}\n\n/* Update modal buttons to use gradients */\n.challenge-modal .cancel-btn {\n    background: linear-gradient(135deg, #666, #444);\n    border: none;\n    padding: 10px 20px;\n    font-size: 16px;\n    transition: all 0.3s ease;\n}\n\n.challenge-modal .cancel-btn:hover {\n    background: linear-gradient(135deg, #777, #555);\n    transform: scale(1.05);\n}\n\n.challenge-modal .confirm-btn {\n    background: linear-gradient(135deg, #ffd700, #daa520);\n    border: none;\n    padding: 10px 20px;\n    font-size: 16px;\n    transition: all 0.3s ease;\n}\n\n.challenge-modal .confirm-btn:hover {\n    background: linear-gradient(135deg, #fff700, #ffd700);\n    transform: scale(1.05);\n    box-shadow: 0 0 15px rgba(255, 215, 0, 0.5);\n} \n\n/* Challenge Response Modal Styles */\n.challenge-response-modal {\n    position: relative;\n    padding-top: 30px !important;\n}\n\n.challenge-response-modal .challenger-avatar {\n    position: absolute;\n    top: -30px;\n    left: -30px;\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    background-size: cover;\n    background-position: center;\n    border: 4px solid #cd853f;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    transition: transform 0.3s ease;\n}\n\n.challenge-response-modal h3 {\n    position: absolute;\n    top: -18px;\n    left: 50%;\n    transform: translateX(-50%);\n    background: var(--background-color);\n    padding: 0 20px;\n    margin: 0;\n    color: white;\n    font-size: 32px;\n    text-transform: uppercase;\n    text-shadow: -2px -2px 0 #000,  \n                  2px -2px 0 #000,\n                 -2px  2px 0 #000,\n                  2px  2px 0 #000;\n    z-index: 2;\n}\n\n.challenge-response-modal::before {\n    content: '';\n    position: absolute;\n    top: -2px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 120px;\n    height: 4px;\n    background: var(--background-color);\n    z-index: 1;\n}\n\n.challenge-response-modal .challenge-description {\n    text-align: center;\n    margin: 30px 0;\n    color: var(--text-color-secondary);\n    font-size: 24px;\n    line-height: 1.4;\n}\n\n.challenge-response-modal .highlight-name {\n    color: #ffd700;\n    font-weight: bold;\n    font-size: 26px;\n}\n\n.challenge-response-modal .button-container {\n    display: flex;\n    gap: 20px;\n    justify-content: center;\n}\n\n.challenge-response-modal .accept-btn {\n    background: linear-gradient(135deg, #4CAF50, #45a049);\n    border: none;\n    padding: 10px 30px;\n    font-size: 16px;\n    transition: all 0.3s ease;\n}\n\n.challenge-response-modal .accept-btn:hover {\n    background: linear-gradient(135deg, #45a049, #4CAF50);\n    transform: scale(1.05);\n}\n\n.challenge-response-modal .decline-btn {\n    background: linear-gradient(135deg, #f44336, #d32f2f);\n    border: none;\n    padding: 10px 30px;\n    font-size: 16px;\n    transition: all 0.3s ease;\n}\n\n.challenge-response-modal .decline-btn:hover {\n    background: linear-gradient(135deg, #d32f2f, #f44336);\n    transform: scale(1.05);\n} \n\n\n.challenge-modal h3 {\n    position: absolute;\n    top: -18px;\n    left: 50%;\n    transform: translateX(-50%);\n    background: var(--background-color);\n    padding: 0 20px;\n    margin: 0;\n    color: white;\n    font-size: 32px;\n    text-transform: uppercase;\n    text-shadow: -2px -2px 0 #000,  \n                  2px -2px 0 #000,\n                 -2px  2px 0 #000,\n                  2px  2px 0 #000;\n    z-index: 2;\n}   \n\n/* Add these styles */\n.profile-name-container {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.edit-name-icon {\n    cursor: pointer;\n    opacity: 0.7;\n    transition: opacity 0.2s;\n    padding: 4px;\n}\n\n.edit-name-icon:hover {\n    opacity: 1;\n}\n\n.name-edit-form {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.name-edit-input {\n    font-size: 24px;\n    padding: 4px 8px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    background: rgba(0, 0, 0, 0.1);\n    color: inherit;\n}\n\n.name-edit-spinner {\n    width: 20px;\n    height: 20px;\n    border: 2px solid transparent;\n    border-top-color: currentColor;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n    margin-left: 8px;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}   \n\n.name-edit-form button {\n    border: none;\n    border-radius: 4px;\n    color: white;\n    padding: 8px 16px;\n    cursor: pointer;\n    font-family: 'Kim', sans-serif;\n    font-size: 14px;\n    transition: all 0.2s ease;\n    text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;\n}\n\n.name-edit-form button[type=\"submit\"] {\n    background: linear-gradient(135deg, #ffd700, #cd853f);\n}\n\n.name-edit-form button[type=\"submit\"]:hover {\n    transform: scale(1.05);\n    background: linear-gradient(135deg, #ffe44d, #dea164);\n    box-shadow: 0 0 10px rgba(255, 215, 0, 0.3);\n}\n\n.name-edit-form button[type=\"button\"] {\n    background: linear-gradient(135deg, #666, #444);\n}\n\n.name-edit-form button[type=\"button\"]:hover {\n    transform: scale(1.05);\n    background: linear-gradient(135deg, #777, #555);\n}   \n\n/* Add these styles */\n.profile-avatar {\n    position: relative;\n}\n\n.profile-avatar:hover .edit-avatar-icon {\n    opacity: 1;\n}\n\n.edit-avatar-icon {\n    position: absolute;\n    bottom: 8px;\n    right: 8px;\n    width: 32px;\n    height: 32px;\n    background: rgba(0, 0, 0, 0.8);\n    border-radius: 50%;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    opacity: 0;\n    transition: opacity 0.2s ease;\n    border: 1px solid rgba(255, 255, 255, 0.4);\n    padding: 8px;\n}\n\n.edit-avatar-icon svg {\n    stroke: #ffffff;\n    opacity: 0.9;\n    width: 100%;\n    height: 100%;\n}\n\n.edit-avatar-icon:hover {\n    background: rgba(0, 0, 0, 0.9);\n    border-color: rgba(255, 255, 255, 0.6);\n}\n\n.edit-avatar-icon:hover svg {\n    opacity: 1;\n}\n\n.avatar-gallery-modal {\n    background: rgba(0, 0, 0, 0.85);\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.avatar-gallery {\n    background: #242b37;\n    padding: 20px;\n    border-radius: 8px;\n    max-width: 90%;\n    max-height: 90vh;\n    overflow-y: auto;\n}\n\n.avatar-gallery-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.avatar-gallery-header h3 {\n    margin: 0;\n    color: #fff;\n}\n\n.avatar-gallery-close {\n    background: none;\n    border: none;\n    color: #fff;\n    cursor: pointer;\n    font-size: 24px;\n    padding: 0;\n}\n\n.avatar-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));\n    gap: 10px;\n    max-width: 600px;\n}\n\n.avatar-option {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    background-size: 120%;\n    background-position: center;\n    cursor: pointer;\n    border: 2px solid transparent;\n    transition: all 0.2s ease;\n}\n\n.avatar-option:hover {\n    border-color: #4a90e2;\n    background-size: 130%;\n}\n\n.avatar-option.selected {\n    border-color: #ffd700;\n    box-shadow: 0 0 10px rgba(255, 215, 0, 0.5);\n    background-size: 130%;\n}   \n\n.avatar-gallery .loading {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: rgba(0, 0, 0, 0.7);  /* Semi-transparent overlay */\n    border-radius: 8px;\n}\n\n.avatar-gallery .loading-spinner {\n    width: 40px;\n    height: 40px;\n    border: 3px solid rgba(255, 255, 255, 0.1);\n    border-top-color: #ffd700;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}   "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
